<template>
    <div class="card-header border border-rounded container-fluid">
        
        <div class="progress" :key="data">
            <div class="progress-bar bgnscblue" role="progressbar" v-bind:style="{width: (data[0]/data[1]*100) + '%'}" aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"><span v-show="data[0]>0">{{(data[0]/data[1]*100).toFixed(0)}}%</span></div>
        </div>
    </div>
</template>
<script>
export default {
    props:['data'],

    
}
</script>
